import React, { FC, ReactNode } from 'react'
import styles from 'styles/components/flex.module.scss'

type Props = {
  alignItems: 'start' | 'end' | 'center'
  children: ReactNode
}

const FlexColumn: FC<Props> = ({ children, alignItems }) => {
  const className = 'flex__column_' + alignItems
  return <div className={styles[className]}>{children}</div>
}

export default FlexColumn
